import { Box } from '@mui/material';
import styles from '../Favorites.module.scss';
import { MyButton, MyDialog } from '@/components';

export const DeleteDialog = ({
  open,
  title,
  onClose,
  onClick,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onClick: () => void;
}) => {
  return (
    <MyDialog open={open} onClose={onClose} dialogTitle={title} width='800'>
      <Box className={styles.submitButtons}>
        <MyButton
          data={{
            buttonName: 'Delete',
            customWidth: '226px',
            variant: 'contained',
            buttonType: 'button',
          }}
          onClick={onClick}
        />
        <MyButton
          data={{
            buttonName: 'Cancel',
            customWidth: '226px',
            styleType: 'cancel',
            variant: 'outlined',
            buttonType: 'button',
          }}
          onClick={onClose}
        />
      </Box>
    </MyDialog>
  );
};
